<!-- Builder Start -->
<div class="position-relative"
  [ngStyle]="{ 'background-color': backgroundColor,'background-image': backgroundColor.includes('#')?'none':backgroundColor }"
  [ngClass]="activatePadding?'header-padding-top':''">
  <div *ngIf="!loading">
    <div [attr.data-aos]="allElementAnimation ? allElementAnimation : null"
      class="app-header-background features-slider"
      [ngStyle]="{ 'background-color': backgroundColor,'background-image': backgroundColor.includes('#')?'none':backgroundColor }">
      <div class="section-block pt-0 pb-40 color-white global-max-width">
        <!-- start: Logos-->
        <div fxLayout="row" fxLayout.sm="column" fxLayout.xs="column" fxLayoutGap="20px">

          <div *ngIf="featureImages.length<=0" class="add-feature" (click)="addNewLogo()">
            <mat-icon (click)="addNewLogo()" class="icon">add_circle</mat-icon>
            <h3 (click)="addNewLogo()">Add new Slide</h3>
          </div>

          <div fxFlex.xs="100%" [attr.data-aos]="textAnimation ? textAnimation : null"
            class="titles-features-slider-container" fxFlex.gt-md="550px" fxFlex.sm="350px">
            <div>
              <h1 [class]="'mb-5 features-slider-title '+titleSize"
                [ngStyle]="{ 'color': titleColor?titleColor:textColor }">{{title}}</h1>
              <!--start sub title-->
              <p class="sub-title mb-20" [ngStyle]="{ 'color': subTitleColor }">{{subTitle}}</p>
              <!--end sub title-->
            </div>
            <ul>
              <li *ngFor="let item of featureImages; let ImageIndex = index"
                [ngClass]="(ImageIndex === indexImageSlider)? 'active-feature':'not-active-feature'"
                (click)="setImageSlider(ImageIndex)">
                {{item.title}}
              </li>
            </ul>
          </div>
          <div [attr.data-aos]="imageAnimation ? imageAnimation : null" fxFlex.xs="100%" fxFlex.gt-md="100%"
            fxFlex.sm="550px" class="images-slider-container">
            <img (click)="openLink(featureImages[indexImageSlider].featureLink)" [alt]="title"
              [src]="featureImages[indexImageSlider].image" class="image-slider">
            <div *ngIf="buttonText" class="button-features-slider">
              <a class="app-button mat-raised-button" mat-raised-button
                [href]="buttonLink ? buttonLink : featureImages[indexImageSlider].featureLink  | safeUrl"
                [target]="buttonLink && buttonLink.includes('#') && buttonLink.length<5 ? '':'_blank'" rel="noopener">
                <span class="mat-button-wrapper"> {{ buttonText }} </span>
              </a>
            </div>
          </div>
        </div>
        <!-- end: Logos -->
      </div>
    </div>
  </div>
</div>